module.exports = __webpack_public_path__ + "static/media/organigramma.4a686766.odt";